import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path opacity=".25" d="M5.5 7.5L5.5 16.5M18.5 16.5L18.5 7.5" vectorEffect="non-scaling-stroke" />
		<Path d="M16.5 5.5L7.5 5.5M7.5 18.5L16.5 18.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
